// src/store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items: [],  // 存放校园失物信息的数组
    foundItems: []  // 存放寻物招领信息的数组
  },
  mutations: {
    ADD_ITEM(state, item) {
      state.items.push(item);
    },
    ADD_FOUND_ITEM(state, item) {
      state.foundItems.push(item);
    }
  },
  actions: {
    addItem(context, item) {
      context.commit('ADD_ITEM', item);
    },
    addFoundItem({ commit }, item) {
      commit('ADD_FOUND_ITEM', item);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js